module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-patuk.ef0e5a03.png";